import React from 'react';

const NlgraphIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    className={className}
    width="1em"
    height="1em"
  >
    <g>
      <path
        d="M2,31.5h5.82c0.83,0,1.5-0.67,1.5-1.5V16c0-0.83-0.67-1.5-1.5-1.5H2c-0.83,0-1.5,0.67-1.5,1.5v14C0.5,30.83,1.17,31.5,2,31.5z"
        fill="currentColor"
      />
      <path
        d="M13.09,31.5h5.82c0.83,0,1.5-0.67,1.5-1.5V9c0-0.83-0.67-1.5-1.5-1.5h-5.82c-0.83,0-1.5,0.67-1.5,1.5v21C11.59,30.83,12.26,31.5,13.09,31.5z"
        fill="currentColor"
      />
      <path
        d="M31.5,30V2c0-0.83-0.67-1.5-1.5-1.5h-5.82c-0.83,0-1.5,0.67-1.5,1.5v28c0,0.83,0.67,1.5,1.5,1.5H30c0.83,0,1.5-0.67,1.5-1.5z"
        fill="currentColor"
      />
    </g>
  </svg>
  );
};

export default NlgraphIcon;
